import { useEffect, useState } from "react";
import { Col, Row, Alert, Container, Image } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiCardRemoveOutline } from "@mdi/js";
import moment from "moment";
import "moment/locale/pt-br";

import { formatarTempoChecagem } from "../../utils/tempo";
import { ordenarPorSaude } from "../../utils/saude";
import { useGetDashboard } from "../../config/swagger";

import DashboardEmbedCard from "../../components/DashboardEmbedCard";

moment.locale("pt-br");

export default function StatusEmbed() {
	const [searchParams] = useSearchParams();
	const token = searchParams.get("t");
	const [enable, setEnable] = useState(false);

	const queryDashboard = useGetDashboard({ query: { enabled: !!token && enable, refetchInterval: 60 * 1000 } });

	useEffect(() => {
		if (token) {
			sessionStorage.setItem("user", JSON.stringify({ token: token }));
			setEnable(true);
		}
	}, [token]);

	return (
		<Container>
			<Row className="mt-3 mb-4">
				{queryDashboard.isLoading && (
					<>
						<Col md={12}>
							<DashboardEmbedCard title="&nbsp;" dataUltimaChecagem="&nbsp;" loading={true} />
						</Col>
						<Col md={12}>
							<DashboardEmbedCard title="&nbsp;" dataUltimaChecagem="&nbsp;" loading={true} />
						</Col>
						<Col md={12}>
							<DashboardEmbedCard title="&nbsp;" dataUltimaChecagem="&nbsp;" loading={true} />
						</Col>
					</>
				)}

				{!queryDashboard.isLoading && (
					<>
						{queryDashboard.data?.Result !== 1 && (
							<Col md={12}>
								<Alert variant="secondary" className="text-center">
									{queryDashboard.data?.Message || "Problema na operação. Tente novamente mais tarde"}
								</Alert>
							</Col>
						)}

						{queryDashboard.data?.Result === 1 && (
							<>
								{!queryDashboard.data?.Data?.length ? (
									<Alert variant="light" className="text-center p-4 d-flex justify-content-center align-items-center">
										<Icon path={mdiCardRemoveOutline} size={1} className="me-2" />
										Nenhum registro encontrado
									</Alert>
								) : (
									ordenarPorSaude(queryDashboard.data.Data).map((item, index) => {
										return (
											<Col md={12} key={index}>
												<DashboardEmbedCard
													id={item.id}
													title={item.nome || "Sem nome"}
													dataUltimaChecagem={formatarTempoChecagem(item.dataUltimaChecagem || "", item.ultimaLatencia || "")}
													monitoresBads={item.monitoresBads}
													monitoresRegulares={item.monitoresRegulares}
													monitoresGoods={item.monitoresGoods}
													saude={item.saude}
												/>
											</Col>
										);
									})
								)}
							</>
						)}
					</>
				)}
			</Row>
			<footer className="text-center text-muted fw-light py-2 mt-auto">
				<a href="https://apps4business.com.br" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
					<Image src={"logo.webp"} alt="Logo" /> Apps4Business
				</a>{" "}
				Copyright © {new Date().getFullYear()}. Todos os direitos reservados.
			</footer>
		</Container>
	);
}
